// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 21 ? "c7286262" : chunkId) + "." + {"1":"e5be0c27f23a17b8","21":"800b1c81f788e075","206":"c49cb86b9917839e","242":"6b79c7df9ab5a333","477":"e4366ac6debe4d5f","872":"05870fba87a0658e"}[chunkId] + ".js";
};